module.exports = __webpack_public_path__ + "img/norway-colorectal-cancer-female.8fdf28c4.png";